import { useContext } from 'react';
import { BirthChartsDataContext } from '../contexts/BirthChartsDataContext';

export const useBirthChartsDataContext = () => {
    return useContext(BirthChartsDataContext);
};
